import { environment } from "src/environments/environment";
import { IAuditableEntity, IEntityBase } from "../shared/models";

export const SALES_ORDER_STATUS_ODATA_URL = `${environment.baseOdataUrl}/OrderStatuses`;
export const CUSTOMERS_ODATA_URL = `${environment.baseOdataUrl}/Customers`;
export const SALES_ORDERS_URL = `${environment.baseApiUrl}/Order`;
export const SALES_ORDERS_ODATA_URL = `${environment.baseOdataUrl}/Orders`;
export const UNIT_OF_MEASURE_ODATA_URL = `${environment.baseOdataUrl}/UnitOfMeasures`;
export const PARTS_ODATA_URL = `${environment.baseOdataUrl}/Parts`;
export const CUSTOMER_PARTS_ODATA_URL = `${environment.baseOdataUrl}/CustomerParts`;
export const SALES_ORDERS_LINES_URL = `${environment.baseApiUrl}/OrderLine`;
export const QUOTATION_STATUS_ODATA_URL = `${environment.baseOdataUrl}/QuotationStatuses`;
export const SALES_ORDERS_LINES_ODATA_URL = `${environment.baseOdataUrl}/OrderLines`;
export const SALES_ORDERS_TERMS_ODATA_URL = `${environment.baseOdataUrl}/OrderTerms`;
export const QUOTATION_TERMS_ODATA_URL = `${environment.baseOdataUrl}/QuotationTerms`;
export const TAX_SLAB_ODATA_URL = `${environment.baseOdataUrl}/TaxSlabs`;
export const TIME_PERIOD_TYPE_ODATA_URL = `${environment.baseOdataUrl}/TimePeriodTypes`;
export const CUSTOMER_ADDRESS_ODATA_URL = `${environment.baseOdataUrl}/CustomerAddresses`;
export const ACCOUNTS_RECEIVABLE_INVOICE_STATUS_URL = `${environment.baseOdataUrl}/AccountsReceivableInvoiceStatuses`;
export const ORDER_CONFIRMATION_ODATA_URL = `${environment.baseOdataUrl}/OrderConfirmations`;
export const QUOTATION_ODATA_URL = `${environment.baseOdataUrl}/Quotations`;
export const SALES_ORDER_LINE_STATUS_ODATA_URL = `${environment.baseOdataUrl}/OrderLineStatuses`;
export const ORDER_RETURN_ACTIONS_ODATA_URL = `${environment.baseOdataUrl}/ReturnActions`;
export const ORDER_RETURN_STATUS_ODATA_URL = `${environment.baseOdataUrl}/ReturnStatuses`;
export const ORDER_RETURN_REASONS_ODATA_URL = `${environment.baseOdataUrl}/OrderReturnReasons`;
export const RETURN_REASONS_ODATA_URL = `${environment.baseOdataUrl}/ReturnReasons`;
export const RELEASE_ODATA_URL = `${environment.baseOdataUrl}/Releases`;
export const ORDER_TYPE_ODATA_URL = `${environment.baseOdataUrl}/OrderTypes`;
export const ORDER_SOURCE_TYPE_ODATA_URL = `${environment.baseOdataUrl}/OrderSourceTypes`;
export const ORDER_PRIORITY_ODATA_URL = `${environment.baseOdataUrl}/OrderPriorities`;
export const SHIPMENT_TYPES_ODATA_URL = `${environment.baseOdataUrl}/ShipmentTypes`;
export const TERM_MAPPING_ODATA_URL = `${environment.baseOdataUrl}/TermMappings`;
export const ORDER_RETURN_ODATA_URL = `${environment.baseOdataUrl}/OrderReturns`;
export const ORDER_RETURN_LINES_ODATA_URL = `${environment.baseOdataUrl}/OrderReturnLines`;
export const PLANT_LOCATION_ODATA_URL = `${environment.baseOdataUrl}/PlantLocations`;
export const LOCATION_TYPE_ODATA_URL = `${environment.baseOdataUrl}/LocationTypes`;
export const RACK_ODATA_URL = `${environment.baseOdataUrl}/Racks`;
export const RACK_CELL_ODATA_URL  = `${environment.baseOdataUrl}/RackCells`;
export const PROJECT_ODATA_URL= `${environment.baseOdataUrl}/Projects`;
export const COMPANY_ODATA_URL = `${environment.baseOdataUrl}/Companies`;
export const TENANT_ADDRESS_ODATA_URL = `${environment.baseOdataUrl}/TenantAddresses`;
export const EMPLOYEE_ODATA_URL = `${environment.baseOdataUrl}/Employees`;

export interface ISalesFilter {
    CustomerId : number | null,
    OrderTypeId : number | any,
    OrderNumber: string,
    OrderStatusId : number | null,
    SupplyFrom : string,
    SupplyTo : string,
    OrderDate : Date | any,
    OrderConfirmationNumber: string,
    OrderPriorityId: number | null
}

export interface ISalesOrder {
    Id? : number,
    CustomerId : number|any,
    AssignedToId: number | any,
    OrderNumber: string,
    PurchaseOrderNumber: string,
    OrderDate: Date | any,
    SupplyDate: Date | any,
    CurrencyCode?: string,
    OrderStatusId: number|any,
    BillingAddressId : number | any,
    ShippingAddressId : number | any,
    ProjectId : number | any,
    ShipmentTypeId : number | any,
    OrderTypeId : number | any,
    OrderSourceTypeId : number | any,
    OrderPriorityId : number | any,
    Remarks: string,
    FullReleased: false,
    SalesOrderDetail?: ISalesOrderDetail  
}

export interface ISalesOrderDetail {
    GrossAmount : string,
    Discount? : string,
    DiscountedAmount? : string,
    Tax : number|any,
    NetAmount : string   
}

export interface ISalesOrderLine {
    Id? : number,
    PartId : number | null,
    CustomerPartNumber : string,
    LeadTime : number | any,
    TimePeriodTypeId : number | any,
    AdditionalDescription: string,
    Quantity : number,
    UnitOfMeasureId : number | null,
    UnitPrice : number,
    NetAmount : number,
    Discount : number | null,
    DiscountedAmount: number | null,
    TaxSlabId: number | null,
    Tax: number,
    GrossAmount : number,
    Remarks: string,
    OrderLineStatusId : number | any,
}

export interface IConfirmOrder {
    Id? : number,
    OrderNumber: string,
    OrderConfirmationNumber: string,
    ConfirmationDate: string| Date,
    Remarks: string
}

export interface IOrderReturn {
    Id? : number,
    OrderId: number | any,
    OrderReturnNumber: string,
    Remarks: string,
}

export interface IOrderReturnLine {
    Id? : number,
    OrderLineId : number | any,
    ReturnActionId : number | any,
    Quantity : number,
    UnitOfMeasureId : number | null,
    ReturnDate: string,
    ReturnStatusId : number | any,
}

export interface IOrderReturnLineDTO{
   Id? : number,
   PartId: number | any,
   OrderLineId : number | any,
   ReturnActionId : number | any,
   Quantity : number,
   UnitOfMeasureId : number | null,
   ReturnDate: Date | any,
   ReturnStatusId : number | any,
   InventoryLocationId: number | any,
   InventoryRackCellId: number | any,
   OrderNumber: string
}

export interface IEditOrderReturnDTO{
    Id? : number,
    PartId: number | any,
    OrderLineId : number | any,
    Quantity: number | any,
    UnitOfMeasureId: number | any,
    ReturnDate: string,
    ReturnActionId : number | any,
    ReturnStatusId : number | any,
}

export interface IOrderReturnReason {
    Id? : number,
    ReturnReasonId : number | any,
    Remarks: string,
}

export interface IReturnReasonFilter {
    Name : string,   
}

export interface IReturnReason extends IEntityBase,IAuditableEntity{
    Id? : number,
    Name : string,
    Description : string,
}

export interface ICreateAccountsReceivableInvoice {
    OrderIds: any,
    ServiceOrderIds: any,  
    CustomerId: number | null,
    InvoiceNumber: string,
    InvoiceDate : Date | any,
    DueDate :  Date | any,
    AccountsReceivableInvoiceStatusId: number | any,
    Remarks: string,
    InvoiceType: number | any  
}

export interface ICreateNegativeInvoice {
    OrderIds: any,
    ServiceOrderIds: any,  
    CustomerId: number | null,
    InvoiceNumber: string,
    InvoiceDate : Date | any,
    DueDate :  Date | any,
    AccountsReceivableInvoiceStatusId: number | any,
    Remarks: string,
}


export interface IQuotationFilter {
    CustomerId: number | null,
    QuotationNumber: string,
    CustomerRequestNumber: string,
    QuotationStatusId: number | null,
    QuotationFrom: string,
    QuotationTo: string,
    SupplyFrom: string,
    SupplyTo: string,
    CustomerConfirmationNumber: string
}

export interface IQuotation {
    Id? : number,
    CustomerId: number | any,
    AssignedToId: number | any,
    QuotationNumber: string,
    CustomerRequestNumber: string,
    QuotationDate: Date | any,
    SupplyDate: Date | any,
    ValidTillDate: Date | any,
    RevisionDate: Date | any,
    CurrencyCode?: string,
    QuotationStatusId: number | any,
    OrderSourceTypeId : number | any,
    ShippingAddressId : number | any,
    ProjectId : number | any,
    Remarks: string,
    VersionName: string,
    SalesOrderDetail?: ISalesOrderDetail 
}

export interface IQuotationLine {
    Id? : number,
    PartId : number | null,
    CustomerPartNumber : string,
    LeadTime : number | any,
    TimePeriodTypeId : number | any,
    AdditionalDescription: string,
    Quantity : number,
    UnitOfMeasureId : number | null,
    UnitPrice : number,
    NetAmount : number,
    Discount : number | null,
    DiscountedAmount: number | null,
    TaxSlabId: number | null,
    Tax: number,
    GrossAmount : number,
    Remarks: string,
}

export interface IConfirmQuotation {
    Id? : number,
    QuotationNumber: string,
    OrderNumber: string,
    CustomerConfirmationNumber: string,
    ShippingAddressId : number | any,
    OrderStatusId: number | any,
    ConfirmationDate: any| Date,
    Remarks: string
}

export interface ISalesOrderTerm{
    Id? : number,
    TermId: number | any,
    PriorityOrder: number | any,
    Value: string,
}

export interface IOrderTypeFilter {
    Name : string,   
}

export interface IOrderType extends IEntityBase,IAuditableEntity{
    Id? : number,
    Name : string,
    Description : string,
}

export interface IOrderSourceType extends IEntityBase,IAuditableEntity{
    Id? : number,
    Name : string,
    Description : string,
}

export interface IOrderReturnFilter {
    CustomerId : number | null,
    OrderNumber: string,
    OrderStatusId : number | null,
    SupplyFrom : string,
    SupplyTo : string,
    OrderReturnNumber: string,
    OrderDate: Date | any,
  }

export interface IOrderStatusFilter  {
    Name: string
}

export interface IOrderStatus {
    Id? : number,
    Name : string,
    Description : string,
    IsDefault: false,
}
export interface IQuotationStatusFilter  {
    Name: string
}

export interface IQuotationStatus {
    Id? : number,
    Name : string,
    Description : string,
    IsDefault: false,
}

export interface IWorkflowStep {
    Id? : number,
    NextStatusId : number | null,
    NextStatusName : string,
    IsCurrent: false
}

export interface OrderReservedInventoryStorage {
    Id? : number,
    OrderId : number | any,
    OrderLineId : number | null,
    PartId : number | null,
    InventoryStorageId : number | any,
    InventoryItemId : number | any,
    ReservedQuantity : number,
}

export interface IProductionPlanData {
    ProductionPlanId : number | null,
    SupplyDate : Date | any,
  }